/* ZERO ONE theme — interactions + AJAX cart */
(function(){
  var hdr=document.querySelector('.hdr');
  var solid=document.body.classList.contains('tmpl-index')?false:true;
  function onScroll(){ if(!hdr) return; if(solid){hdr.classList.add('solid');return;} hdr.classList.toggle('scrolled', window.scrollY>20); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  // reveal
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});

  // swash
  var p=document.getElementById('swashPath');
  if(p && !matchMedia('(prefers-reduced-motion:reduce)').matches){
    var len=p.getTotalLength(); p.style.strokeDasharray=len; p.style.strokeDashoffset=len;
    setTimeout(function(){p.style.transition='stroke-dashoffset 1.6s cubic-bezier(.22,.61,.36,1)';p.style.strokeDashoffset=0;},700);
  }

  // mobile nav
  var burger=document.querySelector('.burger'), drawer=document.getElementById('navDrawer');
  if(burger&&drawer){
    burger.addEventListener('click',function(){var o=drawer.classList.toggle('open');burger.setAttribute('aria-expanded',o);drawer.setAttribute('aria-hidden',!o);});
    drawer.querySelectorAll('[data-close]').forEach(function(a){a.addEventListener('click',function(){drawer.classList.remove('open');burger.setAttribute('aria-expanded',false);});});
  }

  // money formatter (fallback)
  function money(cents){ return '$'+ (cents/100).toFixed(2).replace(/\.00$/,''); }

  // ---- AJAX cart ----
  var drawerCart=document.getElementById('cartDrawer');
  var overlay=document.getElementById('cartOverlay');
  function openCart(){ if(drawerCart){drawerCart.classList.add('open');overlay.classList.add('open');} }
  function closeCart(){ if(drawerCart){drawerCart.classList.remove('open');overlay.classList.remove('open');} }
  if(overlay) overlay.addEventListener('click',closeCart);
  document.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart);});
  document.querySelectorAll('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();renderCart();openCart();});});

  function renderCart(){
    if(!drawerCart) return;
    fetch((window.routes&&window.routes.cart||'/cart')+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){
        var items=drawerCart.querySelector('#cartItems');
        var foot=drawerCart.querySelector('#cartFoot');
        var count=document.querySelectorAll('[data-cart-count]');
        count.forEach(function(el){el.textContent='Cart ('+c.item_count+')';});
        if(!c.items.length){ items.innerHTML='<div class="empty-d">Your cart holds nothing yet.</div>'; foot.innerHTML=''; return; }
        items.innerHTML=c.items.map(function(it){
          var img=it.image?'<img src="'+it.image+'" alt="">':'<div class="ph"></div>';
          var opt=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="meta">'+it.variant_title+' · Qty '+it.quantity+'</div>':'<div class="meta">Qty '+it.quantity+'</div>';
          return '<div class="di">'+img+'<div><div class="nm">'+it.product_title+'</div>'+opt+'</div><div class="lp">'+money(it.final_line_price)+'</div></div>';
        }).join('');
        foot.innerHTML='<div class="row">Subtotal <b>'+money(c.total_price)+'</b></div><a href="'+(window.routes&&window.routes.cart||'/cart')+'" class="btn ghost block" style="margin-bottom:12px;color:var(--paper);border-color:var(--line-d)">View Cart</a><a href="/checkout" class="btn block">Checkout</a>';
      });
  }

  // add to cart (forms with data-ajax)
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form.matches('form[data-ajax]')) return;
    e.preventDefault();
    var btn=form.querySelector('[type=submit]'); var label=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    fetch((window.routes&&window.routes.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/x-www-form-urlencoded'},body:new URLSearchParams(new FormData(form))})
      .then(function(r){return r.json();})
      .then(function(){ if(btn){btn.disabled=false;btn.textContent=label;} renderCart(); openCart(); })
      .catch(function(){ if(btn){btn.disabled=false;btn.textContent=label;} });
  });

  // variant picker (PDP)
  var pdp=document.querySelector('[data-product-json]');
  if(pdp){
    var data=JSON.parse(pdp.textContent);
    var form=document.querySelector('#productForm');
    var idField=form&&form.querySelector('[name=id]');
    var selected={};
    pdp.dataset.optionCount=data.options.length;
    function update(){
      var match=data.variants.find(function(v){return v.options.every(function(o,i){return o===selected[i];});});
      var price=document.querySelector('#pdpPrice');
      var btn=form&&form.querySelector('[type=submit]');
      if(match){
        if(idField) idField.value=match.id;
        if(price) price.innerHTML=(match.compare_at_price>match.price?'<s>'+money(match.compare_at_price)+'</s>':'')+money(match.price);
        if(btn){btn.disabled=!match.available;btn.textContent=match.available?'Add to cart':'Sold out';}
      }
    }
    document.querySelectorAll('.opt .swatches button').forEach(function(b){
      b.addEventListener('click',function(){
        var idx=+b.dataset.optIndex; selected[idx]=b.dataset.value;
        b.parentNode.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed', x===b);});
        update();
      });
    });
    // init defaults
    if(data.variants[0]){ data.variants[0].options.forEach(function(o,i){selected[i]=o;}); 
      document.querySelectorAll('.opt .swatches').forEach(function(grp,i){ var b=grp.querySelector('button'); if(b) b.setAttribute('aria-pressed',true); });
      update(); }
  }

  // qty steppers
  document.querySelectorAll('.qty').forEach(function(q){
    var inp=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){ var v=parseInt(inp.value||'1',10); v+= (b.dataset.dir==='up'?1:-1); if(v<1)v=1; inp.value=v; });
    });
  });
})();
